import React, {useEffect, useRef, useState} from 'react';
import ModalDialog from '../ModalDialog/ModalDialog';
import './TimeOutSession.css';
import {updateAcceptedTermsAndConditions} from '../../redux/app-state-slice';
import {closeTier3ModalEvent, closeModal} from '../../utils/tier-3-modal-close/PrequalCloseEvent';
import {SPECIAL_EVENT_PAGE_NAME} from '../../utils/constants/constants';

export function getTimeRemaining(e) {
  const total = Date.parse(e) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  return {
    total,
    minutes,
    seconds
  };
}

function SessionExpiredHtml() {
  return (
    <div className='prequal--web--timeout-text-container'>
      <div className='prequal--web--reset-session-text'>
        Your prequalification session expired due to inactivity. Any information you provided will not be save or shared.
      </div>
    </div>
  );
}

export function SessionWarningHtml(timer) {
  return (
    <div className='prequal--web--warning-text-container'>
      <div className='prequal--web--session-timer-text'>
        You’ve been inactive for a while. For your security, your session will expire in:
      </div>
      <div className='prequal--web--session-countdown-timer'>{timer}</div>
      <div className='prequal--web--extend-session-text'>
        If you’d like to continue, please click the button below. Otherwise, we will redirect you to the homepage. Please note, your
        information will not be saved or shared.
      </div>
    </div>
  );
}

function TimeOutSession({appConfig, dispatch, customerData, navigate}) {
  const {warningTimeMilliseconds} = appConfig;
  const {sessionEndTimeMilliseconds} = appConfig;

  const [isSessionExpiredActive, setIsSessionExpiredActive] = useState(false);
  const [isLogoutDialogActive, setLogoutDialog] = useState(false);
  const [timer, setTimer] = useState('00 min  00 secs');
  const Ref = useRef(null);

  const [warningTime, setWarningTime] = useState(warningTimeMilliseconds);
  const [signOutTime, setSignOutTime] = useState(sessionEndTimeMilliseconds);
  let warnTimeout;
  let logoutTimeout;
  let isLoggedOut = false;

  const startTimer = (e) => {
    const {total, minutes, seconds} = getTimeRemaining(e);
    if (total >= 0) {
      const timerMinutes = minutes > 9 ? minutes : `0${minutes}`;
      const timerSeconds = seconds > 9 ? seconds : `0${seconds}`;
      setTimer(`${timerMinutes} min  ${timerSeconds} secs`);
    }
  };

  const clearTimer = (e) => {
    setTimer('15 min  00 secs');
    if (Ref.current) clearInterval(Ref.current);
    Ref.current = setInterval(() => {
      startTimer(e);
    }, 1000);
  };
  const getDeadTime = () => {
    const deadline = new Date();
    deadline.setMinutes(deadline.getMinutes() + 15);
    deadline.setSeconds(deadline.getSeconds());
    return deadline;
  };

  const onClickReset = () => {
    clearTimer(getDeadTime());
  };

  const hideSessionIsEndingModal = (toggle) => {
    setIsSessionExpiredActive(!toggle);
    if (!toggle) {
      dispatch(updateAcceptedTermsAndConditions(false));
    }
    onClickReset();
  };

  const warn = () => {
    hideSessionIsEndingModal(false);
  };

  const logout = () => {
    hideSessionIsEndingModal(true);
    setLogoutDialog(true);
    isLoggedOut = true;
  };
  const redirectToLoginPage = () => {
    if (customerData.isDealerHostApplication.value) {
      closeTier3ModalEvent({}, dispatch, customerData);
    } else if (customerData.specialEvent.value) {
      closeModal(dispatch, customerData);
      navigate(`/${SPECIAL_EVENT_PAGE_NAME}`);
    } else {
      document.location.href = '/finance/prequalify';
    }
  };
  const setTimeouts = () => {
    warnTimeout = setTimeout(warn, warningTime);
    logoutTimeout = setTimeout(logout, signOutTime);
  };
  const clearTimeouts = () => {
    if (warnTimeout) clearTimeout(warnTimeout);
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };
  useEffect(() => {
    setWarningTime(warningTimeMilliseconds);
    setSignOutTime(sessionEndTimeMilliseconds);
    const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

    const resetTimeout = () => {
      if (isLoggedOut === false) {
        clearTimeouts();
        setTimeouts();
      }
    };

    events.forEach((event) => {
      window.addEventListener(event, resetTimeout);
      window.addEventListener(event, hideSessionIsEndingModal);
    });

    setTimeouts();
    return () => {
      events.forEach((item) => {
        window.removeEventListener(item, resetTimeout);
        clearTimeouts();
      });
    };
  }, []);

  return (
    !customerData.isDealerHostApplication.value && (
      <div className='prequal-layout-grid mdc-layout-grid--align-center  landing-container-modal'>
        <ModalDialog
          showDialog={isSessionExpiredActive}
          onClose={() => {
            hideSessionIsEndingModal(true);
          }}
          heading='Still With Us?'
          dialogContent={SessionWarningHtml(timer)}
          dialogBoxClasses=''
          hasCloseIcon
          hasCloseButton
          closeButtonText='Extend Session'
          modalType='ExtendSession'
        />
        <ModalDialog
          showDialog={isLogoutDialogActive}
          onClose={redirectToLoginPage}
          heading='Your Session Expired'
          dialogContent={SessionExpiredHtml()}
          dialogBoxClasses=''
          closeButtonText='Close'
          modalType='sessionExpired'
        />
      </div>
    )
  );
}

export default TimeOutSession;
